import InstaTaskSection from './InstaTaskSection';

export default InstaTaskSection;
